import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Compassionate = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24 6.00002C22.494 6.00002 21.087 6.54802 19.998 7.53102C18.936 6.58002 17.535 6.00002 16 6.00002C14.496 6.00002 13.089 6.54502 12 7.52502C10.911 6.54502 9.504 6.00002 8 6.00002C4.692 6.00002 2 8.69102 2 12C2 15.912 4.212 19.869 9.172 24.828C9.917 25.572 10.947 26 12 26C13.053 26 14.084 25.573 14.828 24.828C15.238 24.418 15.627 24.015 16 23.619C16.372 24.016 16.761 24.418 17.171 24.828C17.916 25.572 18.947 26 20 26C21.053 26 22.084 25.573 22.828 24.828C27.788 19.868 30 15.912 30 11.999C30 8.69002 27.308 5.99902 24 5.99902V6.00002ZM13.414 23.414C13.042 23.786 12.526 24 12 24C11.474 24 10.958 23.787 10.586 23.414C6.093 18.921 4 15.294 4 12C4 9.79402 5.794 8.00002 8 8.00002C9.27 8.00002 10.436 8.58302 11.2 9.60102C11.389 9.85202 11.685 10 12 10C12.315 10 12.611 9.85202 12.8 9.60102C13.564 8.58402 14.731 8.00002 16 8.00002C18.206 8.00002 20 9.79402 20 12C20 15.294 17.907 18.921 13.414 23.414ZM21.414 23.414C21.042 23.786 20.526 24 20 24C19.474 24 18.958 23.787 18.586 23.414C18.148 22.976 17.736 22.547 17.343 22.125C20.543 18.379 22 15.175 22 12C22 10.947 21.727 9.95702 21.248 9.09702C21.986 8.39402 22.958 8.00102 24 8.00102C26.206 8.00102 28 9.79502 28 12.001C28 15.295 25.907 18.922 21.414 23.415V23.414Z" />
	</svg>
);

export default Compassionate;
